import { Fragment, useId } from "react";

import * as sx from "./key-value-pair.sx";
import type { KeyValueContainerProps, KeyValueItem } from "./types";

export type KeyValuePairProps = Omit<KeyValueContainerProps, "items"> &
  KeyValueItem;

export function KeyValuePair({
  "data-testid": dataTestId,
  labelTransform = "uppercase",
  component: Component = "div",
  content,
  className,
  ...props
}: KeyValuePairProps & { component?: React.ElementType }) {
  const id = useId();

  const wrapperProps =
    Component === Fragment
      ? null
      : {
          "data-testid": dataTestId,
          className,
        };

  return (
    <Component {...wrapperProps}>
      <sx.Label {...props} id={id} labelTransform={labelTransform} />
      <sx.Content aria-labelledby={id}>{content}</sx.Content>
    </Component>
  );
}

KeyValuePair.slots = {
  Content: sx.Content,
  Label: sx.Label,
};
